import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconAI } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { closeOverflowMenuIfOpen } from '../../../toolbox/actions.web';
import { getState, setOpen, useSiInviteState } from '../../store';
/**
 * The toolbar's "Invite an SI": opens the panel of SIs this signed-in member may bring into the meeting.
 */
class SiInviteToolbarButton extends AbstractButton {
    accessibilityLabel = 'siInvite.button';
    toggledAccessibilityLabel = 'siInvite.close';
    icon = IconAI;
    label = 'siInvite.button';
    tooltip = 'siInvite.buttonTooltip';
    toggledTooltip = 'siInvite.close';
    /**
     * Toggled while the panel is open.
     *
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isOpen;
    }
    /**
     * Opens or closes the panel.
     *
     * @returns {void}
     */
    _handleClick() {
        this.props.dispatch(closeOverflowMenuIfOpen());
        setOpen(!getState().open);
    }
}
const Connected = translate(connect()(SiInviteToolbarButton));
/**
 * The button as the toolbox renders it, reading the panel state.
 *
 * @param {Object} props - What the toolbox passes.
 * @returns {ReactElement}
 */
export default function SiInviteButton(props) {
    const { open } = useSiInviteState();
    return (React.createElement(Connected, { ...props, _isOpen: open }));
}
